import { FC } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { ADMIN_TEST_IDS } from '@connect-x-app/web-test-ids';

import { Button } from '../button/Button';

type Props = {
  isDisabled?: boolean;
  label?: string;
  onClick: () => void;
};

export const AddButton: FC<Props> = ({ isDisabled, label, onClick }) => (
  <Button disabled={isDisabled} iconName="add" isOutline onClick={onClick} testId={ADMIN_TEST_IDS.shared.add} theme="transparent">
    <Text as="span" weight="bold">
      {label}
    </Text>
  </Button>
);
